<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3 v-if="!data">{{ $t('Add Package Feature') }}</h3>
			<h3 v-else>{{ $t('Edit Package Feature') }}</h3>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- Feature Name -->
				<div class="form-group" v-if="!data">
					<select
						name="type"
						class="form-control"
						v-model="featureId"
						required>
						<option
							v-for="featureOption in features"
							:key="featureOption.id"
							:value="featureOption.id">
							{{ featureOption.name }}
						</option>
					</select>
				</div>
				<!-- Description -->
				<div class="form-group">
					<label>{{ $t('Description') }}</label>
					<input type="text" name="description" class="form-control" v-model="description">
				</div>
				<!-- Limit -->
				<div class="d-flex">
					<div class="form-group col-lg-6 pl-0">
						<label v-if="notNumberFeature">{{ $t('Limit') }}</label>
						<custom-input
							v-if="featureId === 5 && notNumberFeature"
							type="number"
							align="left"
							:min="0"
							:max="99999999999999"
							:label="$t('Limit (Mb)')"
							v-model="limit"
						/>
						<custom-input
							v-if="featureId !== 5 && notNumberFeature"
							type="number"
							align="left"
							:min="0"
							:max="1000"
							v-model="limit"
						/>
					</div>
					<!-- type Length -->
					<!-- <div class="form-group col-lg-6 pr-0 pb-0 mb-0">
						<label v-if="featureId !== 6" class="mb-0 pb-0">{{ $t('Limit Type') }}</label>
						<div>
							<MdRadio class="type-length-package md-primary" v-model="limitType" v-if="featureId === 5 && featureId !== 6" value="storage">{{$t('Storage')}}</MdRadio>
							<MdRadio class="type-length-package md-primary" v-model="limitType" v-if="featureId !== 5 && featureId !== 6" value="number">{{$t('Number')}}</MdRadio>
						</div>
					</div> -->
				</div>
				<!-- upload size if storage -->
				<div class="form-group" v-if="limitType === 'storage' && notNumberFeature">
					<div class="d-flex justify-content-between">
						<label class="label mr-4">{{ $t('Upload Size') }}</label>
					</div>
					<div class="form-group mb-0 col-md-6 pl-0">
						<custom-input
							type="number"
							align="left"
							:min="0"
							:max="1024"
							:label="$t('Limit (Mb)')"
							v-model="uploadSize"
						/>
					</div>
					<label class="label">{{ $t('Maximum limit is 1 GB') }}</label>
				</div>
				<!-- Is Published -->
				<label class="custom-control custom-checkbox mb-3">
					<input type="checkbox" class="custom-control-input" v-model="isEnabled">
					<span class="custom-control-label">{{ $t('Enabled') }}</span>
				</label>
				<!-- Submit -->
				<button v-if="!data"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Create Package Feature') }}
				</button>
				<button v-else
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Update Package Feature') }}
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import CustomInput from '@/components/CustomInput.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import packageFeaturesApi from '@/api/package-features';
import featuresApi from '@/api/features';

export default {
	name: 'PackageFeatureForm',
	props: {
		data: {
			type: Object,
		},
		packageId: {
			type: Number,
		},
		newPackageId: {
			type: Number,
		},
		featuresFromParent: {
			type: Array,
		},
	},
	components: {
		Modal,
		CustomInput,
	},
	data() {
		return {
			features: [],
			featureId: 0,
			limit: 0,
			limitType: 'storage',
			isEnabled: false,
			description: '',
			isSaving: false,
			uploadSize: 0,
			existFeature: [],
		};
	},
	methods: {
		fetch(reset = false, page) {
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;

				const index = items.findIndex(({ id }) => id === 6);
				if (index !== -1) {
					items.splice(index, 1);
				}

				for (let index = 0; index < this.featuresFromParent.length; index++) {
					const element = this.featuresFromParent[index].feature_id;
					this.existFeature.push(element);
				}
				for (let indexFeature = 0; indexFeature < items.length; indexFeature++) {
					const elementFeatureId = items[indexFeature].id;
					if (!this.existFeature.includes(elementFeatureId)) {
						const element = items[indexFeature];
						this.features.push(element);
					}
				}
				if (items.length < this.limit) this.isAll = true;
				
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				if (!this.data) this.featureId = this.features[0].id;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Features',
					text: message,
				});
			};
			featuresApi.getList(params, callback, errorCallback);
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			if (this.booleanFeature) params.limit_type = 'boolean';
			const callback = (response) => {
				const feature = response.data;
				const message = response.message;
				this.$emit('saved', feature);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Feature',
					text: message,
				});
				if (this.isApplyToAllUser && feature) this.applyToAllUsers();
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Feature',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				packageFeaturesApi.update(this.data.id, params, callback, errorCallback);
			} else {
				packageFeaturesApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.featureId = 1;
			this.limitType = 'storage';
			this.description = '';
			this.limit = 0;
			this.isEnabled = true;
			this.uploadSize = 0;
		},
		setData(data) {
			this.description = data.description;
			this.featureId = data.feature_id;
			this.limitType = data.limit_type;
			this.limit = data.limit;
			this.isEnabled = data.is_enabled;
			this.uploadSize = data.upload_size;
		},
	},
	computed: {
		fetchParams() {
			const fetchParams = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: this.sortBy,
			};
			return fetchParams;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		params() {
			const params = {
				feature_id: this.featureId,
				limit_type: this.limitType,
				limit: this.limit,
				is_enabled: this.isEnabled,
				description: this.description,
			};
			if (this.packageId) params.package_id = this.packageId;
			if (this.newPackageId) params.package_id = this.newPackageId;
			if (this.limitType === 'storage') params.upload_size = this.uploadSize;
			return params;
		},

		// boolean feature
		notNumberFeature() {
			return this.featureId !== 6 && this.featureId !== 8 && this.featureId !== 9 && this.featureId !== 10 && this.featureId !== 11 && this.featureId !== 12;
		},
		// boolean feature
		booleanFeature() {
			return this.featureId === 6 || this.featureId === 8 || this.featureId === 9 || this.featureId === 10 || this.featureId === 11 || this.featureId === 12;
		},
	},
	watch: {
		featureId() {
			if (this.featureId !== 5) {
				this.limitType = 'number';
			} else {
				this.limitType = 'storage';
			}
			this.description = '';
		},
	},
	created() {
		this.initData();
		this.fetch(true);
	},
};
</script>
